import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SotoreProvider } from './state/MobxContext';
import { RootStore } from './state/RootStore';

const rootStore = new RootStore();

const root = ReactDOM.createRoot(document.getElementById('root'));

// if (window.location.protocol == 'http:') {

//   console.log("you are accessing us via "
//     + "an insecure protocol (HTTP). "
//     + "Redirecting you to HTTPS.");

//   window.location.href =
//     window.location.href.replace(
//       'http:', 'https:')
// }

root.render(
  <SotoreProvider value={rootStore}>
    <App />
  </SotoreProvider>
);
